import React from 'react';
import PropTypes from 'prop-types';
import './Footer.scss';

// import footerLogo from '../../images/footer-logo.svg';
// import newLogoWhite from '../../images/newlogo-white.svg';
import footerUpdatedLogo from '../../images/footer-logo-updated.svg'
import footerBgVideo from '../../images/videos/background-footer-video.mp4'
import { NavLink , useNavigate } from 'react-router-dom';


const Footer = () => {


  const navigate = useNavigate()

  return (
    <div className="Footer relative">
      <div className="main-inner-footer-sec-sub relative z-50">
        <div className="footer-inner-section">
          <div className="container">
            <div className="top-footer-section flex items-center justify-between">
              <div className="left-footer-head-part">
                <h2>Ready To Work With Us</h2>
                <p>Your cargo’s journey, handled with expertise and unwavering commitment.</p>
              </div>
              <div className="right-button-footer">
                <button type='button' className='flex items-center justify-center' onClick={() => navigate('ContactUs')}>
                  <i className="bi bi-arrow-up-right text-3xl text-white"></i>
                </button>
              </div>
            </div>
            <div className="footer-logo-menu-section grid grid-cols-6 gap-10">
              <div className="footer-logo-section col-span-3 ">
                <img src={footerUpdatedLogo} alt="" />
                {/* <p className='text-white font-semibold text-lg w-1/2 leading-normal'>Lorem Ipsum Sit Dolor Emit , Lorem Lorem Ipsum Sit Dolor Emit  Lorem Ipsum Sit Dolor Emit Lorem Ipsum Sit Dolor Emit </p> */}
              </div>
              <div className="right-footer-navigation-part-between col-span-3">
                <div className="inner-right-footer-contact-section flex justify-between">
                  <div className="footer-menu-section flex flex-col gap-[30px]">
                      <ul className='flex flex-col gap-4'>
                        <li><NavLink to={'/Home'}>Home</NavLink></li>
                        <li><NavLink to={'/About-Us'}>About Us</NavLink></li>
                        <li><NavLink to={'/Services'}>Services</NavLink></li>
                        <li><NavLink to={'/Blogs'}>Blogs</NavLink></li>
                      </ul>

                  </div>
                  <div className="address-contact-section-footer">
                    <ul className='flex flex-col gap-6'>
                      <li><a href="mailto:whitetowerinternational@gmail.com" className='text-white font-semibold text-xl flex items-center gap-4'><i className='bi bi-envelope text-xl'></i> <p className="m-0">whitetowerinternational@gmail.com</p></a></li>
                      <li><a href="tel:+96895967179"  className='text-white font-semibold text-xl flex items-center gap-4'> <i className='bi bi-telephone text-xl'></i> <p>+96895967179</p></a></li>
                      <li><a  className='text-white font-semibold text-xl flex items-center gap-4'><i className='bi bi-geo-alt text-xl'></i> <p>Sohar, Oman </p></a></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-copyright-section ">
          <div className="container">
            <div className="inner-footer-copy-container flex items-center justify-between">
              <div className="social-media-list flex items-center gap-6 justify-end">
                <div className="single-social-link-footer">
                  <button type='button' className='' onClick={() => window.open("https://www.instagram.com/whitetower3?igsh=d25mYTl4cHhtaXlm", "_blank")}>
                    <i className="bi bi-instagram text-lg duration-500"></i>
                  </button>
                </div>
                <div className="single-social-link-footer hidden">
                  <button type='button' className=''>
                    <i className="bi bi-twitter-x text-lg duration-500"></i>
                  </button>
                </div>
                <div className="single-social-link-footer">
                  <button type='button' className='' onClick={() => window.open("https://wa.me/+96895967179", "_blank")}>
                    <i className="bi bi-whatsapp text-lg duration-500"></i>
                  </button>
                </div>
              </div>
              <p className=' text-white font-bold'>© Copyright WHITE TOWE INTERNATIONAL LLC - 2015</p>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-bg-video absolute top-0 left-0 w-full h-full">
        <video disablePictureInPicture src={footerBgVideo} className='h-full w-full object-cover' controls={false} autoPlay={true} muted={true} loop={true}></video>
      </div>
    </div>
  );
}

Footer.propTypes = {};

Footer.defaultProps = {};

export default Footer;
